import React from 'react';
import HeroSection from './HeroSection';
import ReadOurBlog from './ReadOurBlog';
import HowWeHelp from './HowWeHelp';
import Newsletter from './Newsletter';
import FAQ from './FAQ';
const ResourcesPage: React.FC = () => {
  return (
    <>
      <HeroSection />
      <ReadOurBlog />
      <HowWeHelp />
      <Newsletter />
      <FAQ />
    </>
  );
};

export default ResourcesPage;
